import { getPageMetaData } from '../services/dbServices/userServices';
import { generalPhases } from '../data/metaDataGeneralPhases';
import { PUBLIC_COMPANIES, PRIVATE_COMPANIES, CRYPTOCURRENCIES } from '../data/directory/topic_classes/topicClassTypes';
import { DCSC_TYPES } from '../data/directory/topicTypes';
import { getMetaTag } from './helpers';
import { DCSC_SECTORS_PATH_ITEM } from '../data/directory/constants';

export function setLocationMetadata(topicName) {
  const generalPhase = generalPhases[
    Math.floor(generalPhases.length * Math.random())
  ];
  const title = `${topicName} ${generalPhase} | CityFALCON`;

  document.title = title;
  getMetaTag('name', 'title').setAttribute('content', title);
  getMetaTag('name', 'description')
    .setAttribute(
      'content',
      `Get latest ${topicName} major breaking news, important updates, financial tweets, insights, and analytics, all in one place!`,
    );
  getMetaTag('name', 'dynamic-meta-tags-current-path')
    .setAttribute(
      'content',
      window.location.pathname.slice(1),
    );
}

export const setSEOTopicMetadata = async ({
  activeTab = 'news', topicName, topicType, topicTicker, figis,
  slugName, isSummary, assetNumber,
}) => {
  let url = '';
  let type = '';
  if (topicType === PUBLIC_COMPANIES) {
    url = `~news/directory/stocks/%/${activeTab}`;
    type = 'Stock';
  } else if (topicType === PRIVATE_COMPANIES) {
    url = `~news/directory/private-companies/%/${activeTab}`;
    type = 'Private Companies and Brands';
  } else if (topicType === CRYPTOCURRENCIES) {
    url = `~news/directory/cryptocurrencies/%/${activeTab}`;
    type = 'Cryptocurrencies';
  } else if (DCSC_TYPES.includes(topicType)) {
    url = `~news/directory/dcsc-sectors/%/%${activeTab !== 'news' ? `/${activeTab}` : ''}`;
    type = topicType.replace(/(\d)$/g, ' $1').replace(/^\w/, (l) => l.toUpperCase());
  } else if (isSummary) {
    url = `news/directory/${slugName}`;
    type = topicType;
  } else {
    url = `~news/directory/${slugName}/%`;
    type = topicType;
  }
  // If the active tab is dcsc-sectors, we don't care about the company type
  if (activeTab === DCSC_SECTORS_PATH_ITEM) {
    url = url.replace(/news\/directory\/\w+\//, 'news/directory/%/');
  }

  const data = await getPageMetaData(url);

  const figiValue = (figis || []).map(({ name }) => name).join(', ');
  Object.values(data).forEach(({ title, meta_tags: metatags }) => {
    if (!metatags || !metatags.length) {
      document.title = 'Finance News, Content, Analytics for all Asset Classes - CityFALCON';
      return;
    }
    const hasTitle = metatags.find((f) => f.name === 'title');
    if (!hasTitle) {
      metatags.push({
        name: 'title',
        content: title,
      });
    }
    for (let i = 0; i < metatags.length; i += 1) {
      const { name, content, property } = metatags[i];
      const formatedText = content
        .replaceAll('%{asset_name}', topicName)
        .replaceAll('%{ticker_names}', topicTicker)
        .replaceAll('%{asset_class}', type)
        .replaceAll('%{asset_open_figi}', figiValue)
        .replaceAll('%{asset_number}', assetNumber);

      if (name === 'title') {
        document.title = formatedText;
      }
      if (property) {
        getMetaTag('property', property).setAttribute('content', formatedText);
      } else {
        getMetaTag('name', name).setAttribute('content', formatedText);
      }
    }
  });
};

export const setFilingsMetadata = async ({
  url, filingTitle, filingDesc,
}) => {
  const data = await getPageMetaData(url);

  Object.values(data).forEach(({ title, meta_tags: metatags }) => {
    if (!metatags || !metatags.length) {
      document.title = 'Finance News, Content, Analytics for all Asset Classes - CityFALCON';
      return;
    }
    const hasTitle = metatags.find((f) => f.name === 'title');
    if (!hasTitle) {
      metatags.push({
        name: 'title',
        content: title,
      });
    }
    for (let i = 0; i < metatags.length; i += 1) {
      const { name, content, property } = metatags[i];
      const formatedText = content
        .replace('%{filing_title}', filingTitle)
        .replace('%{filing_description}', filingDesc);

      if (name === 'title') {
        document.title = formatedText;
      }
      if (property) {
        getMetaTag('property', property).setAttribute('content', formatedText);
      } else {
        getMetaTag('name', name).setAttribute('content', formatedText);
      }
    }
  });
};
